import bannerStrand from '../../assets/images/Banner_Strand.png'
import usaFlag from '../../assets/images/usa-flag.svg'

export const seasonalReturnWindowContent = {
    "sys": {
      "type": "Array"
    },
    "total": 1,
    "skip": 0,
    "limit": 100,
    "items": [
        {
          "fields": {
            "name": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)",
            "title": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)",
            "slug": "notice-of-seasonal-return-window",
            "seo": {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "6SzHWgqbri7KmD1Kqg9tee",
                "type": "Entry",
                "createdAt": "2024-03-08T16:14:42.474Z",
                "updatedAt": "2024-03-08T16:14:42.474Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 2,
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "seo"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "name": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)"
              }
            },
            "content": {
              "metadata": {
                "tags": [],
                "concepts": []
              },
              "sys": {
                "space": {
                  "sys": {
                    "type": "Link",
                    "linkType": "Space",
                    "id": "n9bebhw263o0"
                  }
                },
                "id": "5kvUx9OuWGlyAfzkeuWYmf",
                "type": "Entry",
                "createdAt": "2024-03-08T15:25:40.478Z",
                "updatedAt": "2024-03-08T15:25:40.478Z",
                "environment": {
                  "sys": {
                    "id": "sandbox",
                    "type": "Link",
                    "linkType": "Environment"
                  }
                },
                "publishedVersion": 5,
                "revision": 1,
                "contentType": {
                  "sys": {
                    "type": "Link",
                    "linkType": "ContentType",
                    "id": "richTextContentPageTemplate"
                  }
                },
                "locale": "en-US"
              },
              "fields": {
                "name": "Notice of Seasonal Return Window > Rich Text",
                "modules": [
                  {
                    "metadata": {
                      "tags": [],
                      "concepts": []
                    },
                    "sys": {
                      "space": {
                        "sys": {
                          "type": "Link",
                          "linkType": "Space",
                          "id": "n9bebhw263o0"
                        }
                      },
                      "id": "4wIx2naddOy0wWDJuYy5aw",
                      "type": "Entry",
                      "createdAt": "2024-03-08T15:25:01.040Z",
                      "updatedAt": "2024-03-08T15:25:01.040Z",
                      "environment": {
                        "sys": {
                          "id": "sandbox",
                          "type": "Link",
                          "linkType": "Environment"
                        }
                      },
                      "publishedVersion": 6,
                      "revision": 1,
                      "contentType": {
                        "sys": {
                          "type": "Link",
                          "linkType": "ContentType",
                          "id": "bannerComponent"
                        }
                      },
                      "locale": "en-US"
                    },
                    "fields": {
                      "title": "Notice of Seasonal Return Window > Rich Text > Banner",
                      "headline": "Notice of Seasonal Return Window: COVID-19 Vaccine (2024/2025 Formula)",
                      "backgroundImage": {
                        "metadata": {
                          "tags": [],
                          "concepts": []
                        },
                        "sys": {
                          "space": {
                            "sys": {
                              "type": "Link",
                              "linkType": "Space",
                              "id": "n9bebhw263o0"
                            }
                          },
                          "id": "1Px4l8fvDKjBGrRTCqfWrE",
                          "type": "Asset",
                          "createdAt": "2022-12-29T16:44:45.722Z",
                          "updatedAt": "2022-12-29T16:44:45.722Z",
                          "environment": {
                            "sys": {
                              "id": "sandbox",
                              "type": "Link",
                              "linkType": "Environment"
                            }
                          },
                          "publishedVersion": 5,
                          "revision": 1,
                          "locale": "en-US"
                        },
                        "fields": {
                          "title": "Banner BG strand top right",
                          "description": "Banner BG strand top right",
                          "file": {
                            "url": bannerStrand,
                            "details": {
                              "size": 47693,
                              "image": {
                                "width": 1920,
                                "height": 511
                              }
                            },
                            "fileName": "Banner_BG_strand_right.png",
                            "contentType": "image/png"
                          }
                        }
                      },
                      "country": {
                        "metadata": {
                          "tags": [],
                          "concepts": []
                        },
                        "sys": {
                          "space": {
                            "sys": {
                              "type": "Link",
                              "linkType": "Space",
                              "id": "n9bebhw263o0"
                            }
                          },
                          "id": "7iOWBmppZrkK5s40UUIzOV",
                          "type": "Entry",
                          "createdAt": "2023-09-28T22:24:03.948Z",
                          "updatedAt": "2023-09-28T22:24:03.948Z",
                          "environment": {
                            "sys": {
                              "id": "sandbox",
                              "type": "Link",
                              "linkType": "Environment"
                            }
                          },
                          "publishedVersion": 3,
                          "revision": 1,
                          "contentType": {
                            "sys": {
                              "type": "Link",
                              "linkType": "ContentType",
                              "id": "country"
                            }
                          },
                          "locale": "en-US"
                        },
                        "fields": {
                          "name": "United States",
                          "isocode": "US",
                          "flag": {
                            "metadata": {
                              "tags": [],
                              "concepts": []
                            },
                            "sys": {
                              "space": {
                                "sys": {
                                  "type": "Link",
                                  "linkType": "Space",
                                  "id": "n9bebhw263o0"
                                }
                              },
                              "id": "3aYCbZJiL8aoEKRdhjOXyy",
                              "type": "Asset",
                              "createdAt": "2023-05-24T22:54:50.939Z",
                              "updatedAt": "2023-05-24T22:54:50.939Z",
                              "environment": {
                                "sys": {
                                  "id": "sandbox",
                                  "type": "Link",
                                  "linkType": "Environment"
                                }
                              },
                              "publishedVersion": 5,
                              "revision": 1,
                              "locale": "en-US"
                            },
                            "fields": {
                              "title": "usa flag",
                              "description": "USA Flag",
                              "file": {
                                "url": usaFlag,
                                "details": {
                                  "size": 2487,
                                  "image": {
                                    "width": 36,
                                    "height": 26
                                  }
                                },
                                "fileName": "usa_flag.svg",
                                "contentType": "image/svg+xml"
                              }
                            }
                          },
                          "locales": [
                            "en-US"
                          ]
                        }
                      }
                    }
                  },
                  {
                    "metadata": {
                      "tags": [],
                      "concepts": []
                    },
                    "sys": {
                      "space": {
                        "sys": {
                          "type": "Link",
                          "linkType": "Space",
                          "id": "n9bebhw263o0"
                        }
                      },
                      "id": "3buMSfbhnLWdN0JQh411du",
                      "type": "Entry",
                      "createdAt": "2024-03-08T15:25:24.958Z",
                      "updatedAt": "2024-03-08T15:31:05.586Z",
                      "environment": {
                        "sys": {
                          "id": "sandbox",
                          "type": "Link",
                          "linkType": "Environment"
                        }
                      },
                      "publishedVersion": 26,
                      "revision": 2,
                      "contentType": {
                        "sys": {
                          "type": "Link",
                          "linkType": "ContentType",
                          "id": "richTextContentComponent"
                        }
                      },
                      "locale": "en-US"
                    },
                    "fields": {
                      "title": "Notice of Seasonal Return Window > Rich Text > Content",
                      "content": {
                        "data": {},
                        "content": [
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [],
                                "value": "Dear Valued Partner,",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [],
                                "value": "On behalf of Moderna US, Inc. we are providing an important update regarding returnability of seasonal COVID-19 Vaccine Product (2024-2025 formulation). Pursuant to the Returned Goods Policy and Procedures in your purchase Agreement, at the end of each season a seasonal returns window will open and a percentage of the total volume of the Moderna COVID-19 Vaccine Product purchased directly from Moderna and/or indirectly through an Authorized Distributor that is within your contracted returns allowance may be returned for credit. Any returns received in excess of your contracted return allowance will be destroyed without credit.",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [
                                  {
                                    "type": "bold"
                                  }
                                ],
                                "value": "On April 1, 2025, Moderna will open the seasonal returns window for Moderna’s COVID-19 Vaccine Product with two return windows, as follows:",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Product returned with an approved Return Authorization (RA) received by Inmar Pharmaceutical Services (“Inmar”) between April 1, 2025 and May 31, 2025 will be calculated for credit to be applied to your account upon processing of the returns information at the close of the return window.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Product physically received with an approved RA received by Inmar between June 1, 2025 through October 31, 2025 will be calculated for credit to your account upon processing of the returns information at the close of the return window. Product received after October 31, 2025 will be destroyed and no credit will be issued.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              }
                            ],
                            "nodeType": "unordered-list"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [
                                  {
                                    "type": "bold"
                                  },
                                  {
                                    "type": "underline"
                                  }
                                ],
                                "value": "Additional Considerations",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "We encourage you to maintain sufficient inventory to immunize through Spring and early Summer preceding the new COVID-19 presentations for 2025-26 becoming available.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Please refer to your Moderna purchase Agreement for your defined return allowance percentage.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Health Systems and IDNs could opt to send returns in aggregate and provide their central payer information (if applicable); the contract return allowance percentage will be calculated in aggregate. Returns could also be returned by individual locations. The Returned doses will still be calculated in aggregate to assess the contract allowance percentage for returns.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "If you have purchased through an Authorized Distributor of Record (ADR), please refer to their policies for seasonal returns and allow additional time for credits to be applied to your ADR account. In the event your Wholesaler does not accept returns you may request a Return Authorization as outlined below in the Procedure for Seasonal/Expired Returns.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              }
                            ],
                            "nodeType": "unordered-list"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [
                                  {
                                    "type": "bold"
                                  },
                                  {
                                    "type": "underline"
                                  }
                                ],
                                "value": "Procedure for Seasonal / Expired Product Returns ",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Returns of unexpired Product are accepted as part of seasonal returns and may be returned within either window.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  },
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Seasonal / expired product returns require a Return Authorization (RA) issued through Inmar. To request a RA from Inmar, please Access the Inmar website at: https://hrm.reskureturns.com/landing, and upload a PDF copy of your debit memo.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  },
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Requests for returns must be processed through the Inmar site are subject to denial of the Return.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "For seasonal returns you may submit one request for the entire quantity or multiple locations, but must include the following information above in a formatte",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "content": [
                                          {
                                            "data": {},
                                            "marks": [],
                                            "value": "Customer Name & Address",
                                            "nodeType": "text"
                                          }
                                        ],
                                        "nodeType": "paragraph"
                                      }
                                    ],
                                    "nodeType": "list-item"
                                  },
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "content": [
                                          {
                                            "data": {},
                                            "marks": [],
                                            "value": "Source of Purchase (Moderna directly, or W/D)",
                                            "nodeType": "text"
                                          }
                                        ],
                                        "nodeType": "paragraph"
                                      }
                                    ],
                                    "nodeType": "list-item"
                                  },
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "content": [
                                          {
                                            "data": {},
                                            "marks": [],
                                            "value": "Product Description, NDC, Lot Number(s), Exp Dates, # of Cartons and Doses.",
                                            "nodeType": "text"
                                          }
                                        ],
                                        "nodeType": "paragraph"
                                      }
                                    ],
                                    "nodeType": "list-item"
                                  }
                                ],
                                "nodeType": "unordered-list"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "As a part of the process, Inmar will provide a shipping label to print and affix to the box to return the Product.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "content": [
                                          {
                                            "data": {},
                                            "marks": [],
                                            "value": "Once the RA is issued, Seasonal Products must be physically received at Inmar by October 31, 2025.",
                                            "nodeType": "text"
                                          }
                                        ],
                                        "nodeType": "paragraph"
                                      }
                                    ],
                                    "nodeType": "list-item"
                                  },
                                ],
                                "nodeType": "unordered-list"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Note that if the RA is for multiple locations, each location must return their product by October 31, 2025 in order to receive credit if applicable.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Please contact Inmar at 1-800-967-5952 option 3. Mon. – Fri. 7am – 5pm CT if you have any issues in registering or requesting an RA",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Include the Debit memo and completed RA box label with your return.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Ship returns to the following Inmar location:",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              }
                            ],
                            "nodeType": "unordered-list"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [
                                  {
                                    "type": "bold"
                                  }
                                ],
                                "value": "Inmar Rx Solutions\n3845 Grand Lakes Way\nSuite 125\nGrand Prairie, TX 75050",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "It is shipper’s responsibility to securely package all returned Products to prevent breakage during transit.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "If multiple RAs are being returned within a single box to Inmar, ensure returned Product with the associated RAs are distinctly separated (with appropriate labeling) within the delivery. Failure to do so may result in inaccurate accounting of the return and a delay to the crediting process.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Returned Products do not require refrigerated packaging. ",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Transportation charges, including prepaid freight and insurance, are the responsibility of the customer. No fees of any kind will be approved for credit. Moderna is not responsible for return shipments lost in transit.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              },
                              {
                                "data": {},
                                "content": [
                                  {
                                    "data": {},
                                    "content": [
                                      {
                                        "data": {},
                                        "marks": [],
                                        "value": "Credit for accepted returned Product will be issued subject to the policies of original purchase. Refund for purchases made through an ADR will be credited through the customer account with their ADR, where applicable according to the ADR’s policies.",
                                        "nodeType": "text"
                                      }
                                    ],
                                    "nodeType": "paragraph"
                                  }
                                ],
                                "nodeType": "list-item"
                              }
                            ],
                            "nodeType": "unordered-list"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [
                                  {
                                    "type": "bold"
                                  }
                                ],
                                "value": "Reservation of Rights",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [], 
                                "value": "Moderna reserves the right to modify and make exceptions to this Policy and to its implementation at any time, without advanced notice, for any reason, including due to business necessity or changes in applicable laws and regulations.",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [
                                  {
                                    "type": "bold"
                                  }
                                ],
                                "value": "Any questions regarding Moderna’s Returned Goods Policy can be addressed by Moderna’s Customer Care Team at 1 - 866 - Moderna (663 - 3762) or by emailing wecare@modernatx,com. If you currently work with an account manager, please email sss@modernatx.com.",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [],
                                "value": "Best Regards,",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          },
                          {
                            "data": {},
                            "content": [
                              {
                                "data": {},
                                "marks": [],
                                "value": "Moderna US, Inc. Commercial Operations Team",
                                "nodeType": "text"
                              }
                            ],
                            "nodeType": "paragraph"
                          }
                        ],
                        "nodeType": "document"
                      },
                      "printButtonLabel": "Print",
                      "country": "[Circular Reference]"
                    }
                  }
                ]
              }
            }
          },
          "sys": {
            "id": "1ss0StRsEFrdMIHmkvmgkW",
            "type": "Entry"
          }
        }
      ],
    "includes": {
      "Entry": [
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]",
        "[Circular Reference]"
      ],
      "Asset": [
        "[Circular Reference]",
        "[Circular Reference]"
      ]
    }
}
